import styled from 'styled-components';
import { colors } from '../colors';

interface notificationProps {
	notificationsHolder?: boolean;
}

const Notification = styled.div<notificationProps>`
	position: relative;
	button {
		margin-right: 27px;
		width: auto;
		background: ${colors.White};
		span {
			font-size: 24px;
		}
		&:hover {
			background: ${colors.White};
		}
		&:after {
			display: none;
		}
	}
	${({ notificationsHolder }) =>
		notificationsHolder &&
		`width:auto;
		button{
			+ div{
				top:50px;
				box-shadow: none;
				border-radius: 0;
				:before,:after{
					display:none
				}
			}
		}
	`}
`;

export default Notification;
